/**
 * Thin React wrappers over nedi-ui-web layout custom elements (contract 2.0.0).
 */
import { createElement } from 'react'

function ce(tag, { className, children, ...rest }) {
  const attrs = { ...rest }
  if (className) attrs.class = className
  return createElement(tag, attrs, children)
}

export function NediScreen(props) {
  return ce('nedi-screen', props)
}

export function NediStack({ gap, ...props }) {
  const attrs = { ...props }
  if (gap) attrs.gap = gap
  return ce('nedi-stack', attrs)
}

export function NediInline(props) {
  return ce('nedi-inline', props)
}

export function NediPanel(props) {
  return ce('nedi-panel', props)
}
